$(function () {
  $('select').multipleSelect({
      width: 200,
      formatSelectAll: function() {
          return 'すべて';
      },
      formatAllSelected: function() {
          return '全て選択されています';
      }
  });
});

(() => {
  const targetId = "QuestionnaireForm";
  const buttonId = "js-submit-button";
  const target = document.getElementById(targetId);
  const $target = $(`#${targetId} :input`);
  const button = document.getElementById(buttonId);

  const googleAppsScriptUrl = "https://script.google.com/macros/s/AKfycbyhAjCg4_G0kj7AsPVazrrqq8UUzCXMlta_CV7UN2-ss-FGslcHiaxXM-s4hGjarlmMag/exec";

  /**
   * @param {array} formArray [{name: 'name', value: 'value'}]
   * @return {object}  {'name': 'value'}
   */
  const objectifyForm = (formArray) => {
    const returnObject = {};
    for (let i = 0; i < formArray.length; i++) {
      returnObject[formArray[i]["name"]] = formArray[i]["value"];
    }
    return returnObject;
  };

  const getRedirectUrl = () => {
    const url = location.href;
    const urlParam = location.search.substring(1);
    if (!urlParam) {
      return `${url}?contact_posted=true`;
    }
    if (!urlParam.match(/contact_posted=true/)) {
      return `${url}&contact_posted=true`;
    }
    return url;
  };

  const redirect = (url) => {
    location.href = url;
  };

  window.addEventListener("DOMContentLoaded", () => {
    if (!target) {
      return;
    }
    target.addEventListener("submit", (event) => {
      event.preventDefault();
      button.disabled = true;
      let targetValues = $target.serializeArray();
      let object = []
      for(let i = 0; i < targetValues.length; i++) {
        if (i == 0 || targetValues[i].name !== targetValues[i-1].name) {
          object.push({name: targetValues[i].name, value: targetValues[i].value})
        } else {
          object[object.length - 1].value += `,${targetValues[i].value}`
        }
      }
      console.log(object);
      const formObject = objectifyForm(object);
      const postParameter = {
        method: "POST",
        mode: "no-cors",
        "Content-Type": "text/plain",
        body: JSON.stringify(formObject),
      };
      fetch(googleAppsScriptUrl, postParameter).finally(() => {
        redirect(getRedirectUrl());
      });
    });
  });
})();
